enum AgeClass {
	Minus45 = "Minus45",

	Plus45 = "Plus45",

	SWT = "SWT"
}

export default AgeClass;
